define 'controller/TextareaController', ['jquery'], ($) ->
  class TextareaController

    constructor: (@$el) ->
      _autoresize(@$el)
      @$el.on 'keyup keydown autoresize', (e) ->
        _autoresize(@)

    destroy: ->
      @$el.off()

    _autoresize = ($textarea) ->
      if $textarea instanceof Element
        $textarea = $($textarea)

      hiddenDiv = $('.hiddendiv').first()
      if !hiddenDiv.length
        hiddenDiv = $('<div class="hiddendiv common"></div>')
        $('body').append hiddenDiv

      _setPadding(hiddenDiv, $textarea)
      _setHeight(hiddenDiv, $textarea)
      return

    _setPadding = (hiddenDiv, textarea) ->
      fontFamily = textarea.css('font-family')
      fontSize = textarea.css('font-size')
      lineHeight = textarea.css('line-height')
      paddingTop = textarea.css('padding-top')
      paddingRight = textarea.css('padding-right')
      paddingBottom = textarea.css('padding-bottom')
      paddingLeft = textarea.css('padding-left')
      if fontSize
        hiddenDiv.css 'font-size', fontSize
      if fontFamily
        hiddenDiv.css 'font-family', fontFamily
      if lineHeight
        hiddenDiv.css 'line-height', lineHeight
      if paddingTop
        hiddenDiv.css 'padding-top', paddingTop
      if paddingRight
        hiddenDiv.css 'padding-right', paddingRight
      if paddingBottom
        hiddenDiv.css 'padding-bottom', paddingBottom
      if paddingLeft
        hiddenDiv.css 'padding-left', paddingLeft

    _setHeight = (hiddenDiv, textarea) ->
      if !textarea.data('original-height')
        textarea.data 'original-height', textarea.height()
      if textarea.attr('wrap') == 'off'
        hiddenDiv.css('overflow-wrap', 'normal').css 'white-space', 'pre'
      hiddenDiv.text textarea[0].value + '\n'
      content = hiddenDiv.html().replace(/\n/g, '<br>')
      hiddenDiv.html content

      if textarea.data('original-height') <= hiddenDiv.innerHeight()
        textarea.css 'height', (hiddenDiv.innerHeight() - 40) + 'px'
      else if textarea[0].value.length < textarea.data('previous-length')
        textarea.css 'height', (textarea.data('original-height') - 40) + 'px'
      textarea.data 'previous-length', textarea[0].value.length